module.exports = __webpack_public_path__ + "img/icon-documentation.6fb7c041.svg";